import { initTabs } from "./agendaTab";
import { initForms, initStickyRow } from "./registerForm";
import { initRegisterModal } from "./registerForm";
import { DefaultArchiveTemplate } from "./templates/archive/default";
(function ($) {
    "use strict";
    if (jQuery(".post-type-archive-hora_event").length > 0) {
        new DefaultArchiveTemplate();
    }
    if (jQuery(".hora-event-agenda__tabs").length > 0) {
        initTabs();
    }
    initRegisterModal();
    initForms();
    const formEl = jQuery(".hora-events-single-event .hora-event-register-form")[0];
    initStickyRow(formEl, formEl === null);
})(jQuery);
